// SecureFileService: centraliza la obtención de archivos seguros (blob) a partir de una ruta o URL
import { Injectable, computed, inject } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { environment } from '@environment'
import { AuthStore } from '@shared/store'
import { ECountry } from '@shared/models'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class SecureFileService {
	readonly #http = inject(HttpClient)
	readonly #authStore = inject(AuthStore)

	gateway = computed<string>(() => {
		switch (this.#authStore.country()) {
			case ECountry.mexico:
				return environment.operationGatewayMexico
			default:
				return environment.gateway
		}
	})

	constructor() {}

	getViewUrl(filePath: string): string {
		return `${this.gateway()}/fileshare/view?filename=${encodeURIComponent(filePath)}`
	}

	getSecureImageWithToken(filePath: string): Observable<string> {
		const url = this.getViewUrl(filePath)
		const token = this.#authStore.accessToken()
		const headers = new HttpHeaders({ Authorization: `Bearer ${token}` })

		return this.#http
			.get(url, { headers, responseType: 'blob' })
			.pipe(map((blob: Blob) => URL.createObjectURL(blob)))
	}
}
